// File: DataGridPage.js
import { DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
  FormControlLabel,
  Typography,
  Checkbox,
} from "@mui/material";
import { useEffect } from "react";
import useSharedLink from "../../scenes/SharedLink";
import { useTheme } from "@mui/material";
import Header from "../../components/Header";
import { tokens } from "../../theme";
import { DataGridPro } from "@mui/x-data-grid-pro";
import LoadingIndicator from "../../scenes/Loader";
import { useSnackbar } from "../../components/SnackBarProvider"; // Import SnackbarProvider

import { Edit, Delete } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import DialogForm from "./AddDialog";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteConsentFormAction,
  reactivateConsentFormAction,
  saveConsentFormsAction,
  updateConsentFormAction,
} from "../../Redux/ActionCreators/ClientAccessActionCreator";
import { usePermissions } from "../../Phase3/CheckPermission";
import { getConsents } from "../../Redux/ActionCreators/ClientAccessActionCreator";
import { buttonStyle, dataGridStyle } from "../../constants";
const initialRows = [
  {
    id: 1,
    name: "John Doe",
    email: "john@example.com",
    status: "Active",
    relation: "Father",
  },
  {
    id: 2,
    name: "Jane Smith",
    email: "jane@example.com",
    status: "Inactive",
    relation: "Mother",
  },
];

export default function Consent() {
  const theme = useTheme();
  const { openSnackbar } = useSnackbar();
  const { checkAllClientPermission, giveClientsForGuardian } = usePermissions();
  const sharedLink = useSharedLink();
  const colors = tokens(theme.palette.mode);
  const [rows, setRows] = useState([]);
  const [rowModesModel, setRowModesModel] = useState({});
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [includeInactive, setIncludeInactive] = useState(false);
  const [fetchedClients, setFetchedClients] = useState([]); // ✅ New State for Clients

  const dispatch = useDispatch();
  const allusers =
    useSelector((state) => state?.clientAccess?.consentDetails) || [];
  console.log("allusers in consent", fetchedClients);

  useEffect(() => {
    async function fetchClients() {
      try {
        const clients = await giveClientsForGuardian(); // Await Promise resolution
        console.log("Fetched Clients:", clients);
        setFetchedClients(clients || []);
      } catch (error) {
        console.error("Error fetching clients:", error);
        setFetchedClients([]); // Ensure it's always an array
      }
    }
    fetchClients();
  }, []);
  useEffect(() => {
    dispatch(getConsents(checkAllClientPermission));
  }, []);
  useEffect(() => {
    console.log("all users", allusers);
    if (includeInactive) {
      setRows(allusers); // Include all users (active and inactive)
    } else {
      setRows(allusers.filter((user) => user.status === "Active")); // Include only active users
    }
  }, [allusers, includeInactive]);

  const handleAddClick = () => {
    setSelectedRow(null);
    setIsEditMode(false);
    setOpenDialog(true);
  };

  const handleEditClick = (row) => {
    setSelectedRow(row);
    setIsEditMode(true);
    setOpenDialog(true);
  };

  const handleDeleteClick = (row) => {
    setSelectedRow(row);
    setOpenDeleteConfirm(true);
  };

  const handleDeleteConfirm = () => {
    dispatch(deleteConsentFormAction({ id: selectedRow.id }, openSnackbar));
    // setRows(rows.filter((row) => row.id !== selectedRow.id));
    setOpenDeleteConfirm(false);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedRow(null);
  };

  const handleFormSubmit = (formData, type = null) => {
    if (type && type == "reactivate") {
      dispatch(reactivateConsentFormAction(formData, openSnackbar));
      return;
    }
    if (isEditMode) {
      dispatch(updateConsentFormAction({ ...formData }, openSnackbar));
      //   setRows(rows.map((row) => (row.id === formData.id ? formData : row)));
    } else {
      dispatch(saveConsentFormsAction({ ...formData }, openSnackbar));

      //   setRows([...rows, { id: rows.length + 1, ...formData }]);
    }
    setOpenDialog(false);
  };
  const handleCheckboxChange = (event) => {
    setIncludeInactive(event.target.checked);
    if (event.target.checked) {
      setRows(allusers);
    } else {
      setRows(allusers.filter((row) => row.status === "Active"));
    }
  };
  const columns = [
    { field: "firstName", headerName: "Name", width: 150 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "status", headerName: "Status", width: 120 },
    { field: "relationship", headerName: "Relation", width: 150 },
    { field: "phone", headerName: "Phone", width: 150 },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => (
        <>
          <IconButton
            onClick={() => handleEditClick(params.row)}
            color="primary"
          >
            <Edit />
          </IconButton>
          <IconButton
            disabled={params.row.status == "Inactive"}
            onClick={() => handleDeleteClick(params.row)}
            color="danger"
          >
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <div>
      <Box sx={{ width: "90%", margin: "0 auto", textAlign: "center", mt: 4 }}>
        {/* ✅ Centered Header */}
        <Typography variant="h3" fontWeight="bold" color="#3A57E8" mb={3}>
          Consent Authorities
        </Typography>

        {/* ✅ Top Controls: "Include Inactive" on the Left & "Add" Button on the Right */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={includeInactive}
                onChange={handleCheckboxChange}
                name="includeInactive"
              />
            }
            label="Include Inactive"
          />
          <Button
            variant="contained"
            color="secondary"
            sx={{ ...buttonStyle }}
            startIcon={<AddIcon />}
            onClick={handleAddClick}
          >
            Add
          </Button>
        </Box>
        <Box
          //   height="60vh"
          sx={{
            width: "100%",
            mt: 4,
            ml: "auto",
            mr: "auto",
            textAlign: "center",
            backgroundColor: "#f9f9f9",
            borderRadius: 2,
            p: 3,
          }}
        >
          <DataGrid
            initialState={{
              pagination: { paginationModel: { pageSize: 25 } },
              columns: {
                columnVisibilityModel: {
                  id: false,
                  facilityId: false,
                  lastUpdatedBy: false,
                  lastUpdatedTime: false,
                  clientId: false,
                  enteredTime: false,
                  enteredBy: false,
                },
              },
            }}
            sx={{
              ...dataGridStyle,
              "& .MuiDataGrid-footerContainer": {
                justifyContent: "space-between", // ✅ Proper alignment
                padding: "10px 20px", // ✅ Adds padding for spacing
                backgroundColor: "#3A57E8", // ✅ Matching footer background
                display: "flex", // ✅ Uses flexbox for better alignment
                alignItems: "center", // ✅ Ensures everything is centered properly
              },
              "& .MuiTablePagination-toolbar": {
                display: "flex",
                justifyContent: "space-between",
                width: "100%", // ✅ Ensure it takes full width
              },
              "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                {
                  color: "#fff", // ✅ White text for "Rows per page" and pagination details
                  fontSize: "14px", // ✅ Improve readability
                  marginBottom: "2px", // ✅ Fix slight misalignment
                  color: "#fff", // ✅ White color for pagination buttons
                },
              "& .MuiTablePagination-actions button": {
                color: "#fff", // ✅ White color for pagination buttons
              },
              "& .MuiTablePagination-root .MuiSvgIcon-root": {
                color: "#fff", // ✅ White color for dropdown icon
              },
              "& .MuiSelect-select": {
                color: "#fff !important", // ✅ Makes the dropdown text white
                fontSize: "14px !important", // ✅ Increases font size
                fontWeight: "bold", // ✅ Makes it slightly bolder for better visibility
                marginTop:"3px"
              },
              "& .MuiOutlinedInput-input": {
                color: "#fff !important",
                fontSize: "16px !important", // ✅ Ensures larger font size inside the dropdown
                fontWeight: "bold",
              },
              "& .MuiSelect-icon": {
                color: "#fff !important",
                fontSize: "20px !important", // ✅ Makes the dropdown arrow bigger
              },
              "& .MuiDataGrid-selectedRowCount": {
                color: "#fff !important", // ✅ Changes "1 row selected" text to white
                fontSize: "14px", // ✅ Slightly bigger for better readability
              },
            }}
            pageSizeOptions={[25, 50, 100]}
            rows={rows}
            columns={columns}
            editMode="row"
            rowModesModel={rowModesModel}
            // onRowModesModelChange={handleRowModesModelChange}
            // onRowEditStop={handleRowEditStop}
            // processRowUpdate={processRowUpdate}
            slotProps={{
              toolbar: { setRows, setRowModesModel },
            }}
            isCellEditable={false}
            onRowDoubleClick={(params) => {
              handleEditClick(params.row.id)();
            }}
          />
        </Box>
      </Box>
      {openDialog && (
        <DialogForm
          open={openDialog}
          handleClose={handleDialogClose}
          handleSubmit={handleFormSubmit}
          isEditMode={isEditMode}
          rowData={selectedRow}
          fetchedClients={fetchedClients}
        />
      )}
      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteConfirm}
        onClose={() => setOpenDeleteConfirm(false)}
      >
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this record?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenDeleteConfirm(false)}
            sx={{
              backgroundColor: "red",
              color: "white",
              "&:hover": {
                backgroundColor: "darkred",
              },
            }}
          >
            Cancel
          </Button>

          <Button
            sx={{
              backgroundColor: "blue",
              color: "white",
              "&:hover": {
                backgroundColor: "darkblue",
              },
            }}
            onClick={handleDeleteConfirm}
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
